import {
  Dashboard,
  Tokens,
  BuyOperatorTokenView,
  BuyOperatorDualView,
  Transactions,
  Message,
  TransactionEmail,
  TransactionLogin,
} from "containers";
import ReserveDualView from "containers/ReserveDualView";

const Routes = [
  { path: "/", component: Dashboard, auth: false },
  { path: "/message", component: Message },
  { path: "/transactions", component: Transactions, auth: false },
  { path: "/transactions/email", component: TransactionEmail, auth: false },
  { path: "/transactions/login", component: TransactionLogin, auth: false },

  { path: "/buy-ticket", component: BuyOperatorTokenView, auth: false },
  { path: "/reserve-seat-details", component: ReserveDualView, auth: false },
  {
    path: "/ticket-details",
    component: BuyOperatorDualView,
    auth: false,
  },
];
export default Routes;
